module.exports = __webpack_public_path__ + "img/complete.c3dff676.svg";